import React, { useEffect, useState } from "react";
import { getManagers } from "../../api/managers";
import { useApiActivity } from "../../contexts/ApiActivityContext";
import "./Div3Dropdown.css";

const Div3ManagerSelection = ({
  shouldFetchManager,
  enteredEmail,
  activeStep,
  onSelectManager,
  title,
  buttonLabel,
  action,
}) => {
  const { isActive, beginActivity, endActivity } = useApiActivity();
  const [managerData, setManagerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedManager, setSelectedManager] = useState("");

  useEffect(() => {
    if (shouldFetchManager) {
      const getManagerData = async () => {
        setLoading(true);
        setError(null);
        beginActivity("manager-lookup");

        try {
          const { managerInfo, errorMsg } = await getManagers(enteredEmail);
          if (managerInfo) {
            // Backend returns nullable placeholders for missing managers.
            const filteredManagerInfo = managerInfo.manager_chain.filter(
              (manager) => manager.name != null && manager.email !== null
            );
            setManagerData(filteredManagerInfo);
          } else if (errorMsg) {
            setError(errorMsg);
          }
        } finally {
          setLoading(false);
          endActivity("manager-lookup");
        }
      };

      getManagerData();
    }
  }, [shouldFetchManager, enteredEmail]);

  const handleDropdownChange = (e) => {
    setSelectedManager(e.target.value);
  };

  const handleButtonPress = () => {
    if (selectedManager) {
      const [selectedName, selectedEmail] = selectedManager.split("|");
      onSelectManager({
        managerName: selectedName,
        managerEmail: selectedEmail,
      });
    }
  };

  return (
    <div className={`child-div ${activeStep === 3 ? "active-step" : ""}`}>
      {loading ? (
        <div className="app-div-subtitle">Searching managers...</div>
      ) : error ? (
        <div className="app-div-subtitle app-error">Error: {error}</div>
      ) : (
        <>
          <div className="app-div-subtitle">{title}</div>
          <div className="app-text">
            <p>{action} must be completed by user's manager.</p>
          </div>

          <select
            className="dropdown"
            value={selectedManager}
            onChange={handleDropdownChange}
          >
            <option value="" disabled>
              Select a manager
            </option>
            {managerData.map((manager, index) => (
              <option key={index} value={`${manager.name}|${manager.email}`}>
                [{index}] {manager.name}
              </option>
            ))}
          </select>

          <button
            disabled={!selectedManager || isActive}
            className={`app-button ${
              selectedManager && !isActive ? "button-valid" : "button-invalid"
            }`}
            onClick={handleButtonPress}
          >
            {buttonLabel}
          </button>
        </>
      )}
    </div>
  );
};

export default Div3ManagerSelection;
